import {createContext} from "react"
import {DecodedJwt} from "@/library/utilities/jwt"
import {Credentials} from "@/library/api/models/auth"

export type Auth = {
    jwtData?: DecodedJwt
    token?: string | 'initializing'
    roles: string[]
    isLoading?: boolean
    logout: () => void
    login: (login: Credentials) => Promise<void>
}

export const AuthContext = createContext<Auth>({
    roles: [],
    logout: () => {
        throw new Error("No logout was provided...")
    },
    login: () => {
        throw new Error("No login was provided...")
    }
})
